import $ from 'jquery'
import Cookies from 'js-cookie'
import { Modal } from 'bootstrap'
const object = vnObject

const themeSwitch = new BroadcastChannel('themeSwitch')
const body = document.body

const setTheme = (theme) => {
  Cookies.set('theme', theme, { expires: 365 })
  document.documentElement.setAttribute('data-theme', theme)
}

const initializeTheme = () => {
  const savedTheme = Cookies.get('theme') || 'dark'
  setTheme(savedTheme)
}

document.addEventListener('DOMContentLoaded', initializeTheme)

document.querySelector('.js-switcher').addEventListener('click', () => {
  const theme = document.documentElement.getAttribute('data-theme')
  const newTheme = theme && theme === 'light' ? 'dark' : 'light'
  setTheme(newTheme)
  themeSwitch.postMessage(newTheme)
})

const setScrollbarWidth = () => {
  const documentWidth = document.documentElement.clientWidth
  const width = Math.abs(window.innerWidth - documentWidth)
  body.style.setProperty('--scrollbar-width', `${width}px`)

  const mainContainer = document.querySelector('#colophon > .container')
  const mainContainerWidth = mainContainer.clientWidth

  body.style.setProperty(
    '--space-width',
    `${(documentWidth - mainContainerWidth) / 2 + 20}px`
  )

  body.style.setProperty('--container-width', `${mainContainerWidth}px`)
  body.style.setProperty('--main-width', `${documentWidth}px`)
}

setScrollbarWidth()
window.addEventListener('load', setScrollbarWidth)
window.addEventListener('resize', setScrollbarWidth)

const setThemeVars = () => {
  const documentWidth = document.documentElement.clientWidth
  const width = Math.abs(window.innerWidth - documentWidth)
  body.style.setProperty('--scrollbar-width', `${width}px`)

  const mainContainer = document.querySelector('#colophon > .container')
  const mainContainerWidth = mainContainer.clientWidth

  const col = document.querySelector('.vn-col-sizer')
  const colWidth = col.clientWidth

  body.style.setProperty(
    '--space-width',
    `${(documentWidth - mainContainerWidth) / 2 + 20}px`
  )

  body.style.setProperty('--container-width', `${mainContainerWidth}px`)
  body.style.setProperty('--main-width', `${documentWidth}px`)
  body.style.setProperty('--col-width', `${colWidth}px`)
}

setThemeVars()
window.addEventListener('load', setThemeVars)
window.addEventListener('resize', setThemeVars)

const input = $('.js-modal-input')
input
  .autocomplete({
    minLength: 3,
    appendTo: input.parent().find('.js-modal-result'),
    source: function (request, response) {
      $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        dataType: 'JSON',
        data: {
          _ajax_nonce: object.nonce,
          action: 'vn_get_posts',
          keyword: request.term,
          postType: 'page,post,service,numerical_service',
        },
        success: function (res) {
          response(res.data.data)
        },
      })
    },
    search: function (event) {
      $(event.target)
        .parents('.search-modal')
        .addClass('search-modal--searching')
    },
    open: function (event) {
      $(event.target).parents('.search-modal').addClass('search-modal--active')
      $(event.target).addClass('autocomplete-active')
    },
    close: function (event) {
      $(event.target)
        .parents('.search-modal')
        .removeClass('search-modal--active')
      $(event.target).removeClass('autocomplete-active')
    },
    response: function (event) {
      $(event.target)
        .parents('.search-modal')
        .removeClass('search-modal--searching')
    },
    create: function () {
      $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
        return $('<li>')
          .append(
            `<a href="${item.url}" data-id="${item.id}" class="ajax-post${
              !item.success ? ' ajax-post--error' : ''
            }">${
              item.thumbnail
                ? `<img src="${item.thumbnail}" alt="${item.name}">`
                : ''
            }<div><span class="ajax-post__title">${item.title}</span></div></a>`
          )
          .appendTo(ul)
      }
    },
  })
  .focus(function () {
    $(this).data('uiAutocomplete').search($(this).val())
  })

const jsContainer = () => {
  if ($('.js-container').length) {
    const bodyWidth = $('body').outerWidth()
    $('.js-container').css({
      width: bodyWidth,
      marginLeft: `calc(${-bodyWidth / 2}px + 50%)`,
    })
  }
}

jsContainer()
window.addEventListener('load', jsContainer)
window.addEventListener('resize', jsContainer)

$('.vn-btn-terms button').on('click', function (e) {
  e.preventDefault()
  e.stopPropagation()
  e.stopImmediatePropagation()
  const button = $(this)
  const href = button.attr('data-url')

  window.location.href = href
})

jQuery.ui.autocomplete.prototype._resizeMenu = function () {
  var ul = this.menu.element
  ul.outerWidth(this.element.outerWidth())
}

$('a[href="#cookies"]').on('click', (e) => {
  e.preventDefault()
  window.openAxeptioCookies()
})
